// src/hooks/useProfileForm.js
import { useState } from 'react';
import { userProfileService } from 'services/recruitersService';
import { useSnackbar } from './useSbackbar';

export const useProfileForm = (initialData = {}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  // const [showSnackbar, setShowSnackbar] = useState(false);
  const { showSnackbar } = useSnackbar();

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleSave = async (userId, formData) => {
    try {
      setLoading(true);
      await userProfileService.updateProfile(userId, formData);
      // setShowSnackbar(true);
      // showSnackbar("Profile updated successfully", 'success');
      showSnackbar('Profile updated successfully', {
        severity: 'success',
        position: 'top-right',
        duration: 3000
      });
      setIsEditing(false);
    } catch (err) {
      // showSnackbar("Failed to update profile", 'error');
      showSnackbar('Failed to update profile', {
        severity: 'error',
        position: 'top-right',
        duration: 3000
      });
      setError("Failed to update profile");
      console.error("Error updating recruiter:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleImageUpload = async (file) => {
    try {
      const imageUrl = await userProfileService.uploadImage(file);
      // showSnackbar("Image uploaded succesfully", 'success');
      showSnackbar('Image uploaded succesfully', {
        severity: 'success',
        position: 'top-right',
        duration: 3000
      });
      return imageUrl;
    } catch (err) {
      console.error("Error uploading image:", err);
      // showSnackbar("Failed to upload image", 'error');
      showSnackbar('Failed to upload image', {
        severity: 'error',
        position: 'top-right',
        duration: 3000
      });
      setError("Failed to upload image");
      return null;
    }
  };

  return {
    isEditing,
    loading,
    error,
    showSnackbar,
    setIsEditing,
    // setShowSnackbar,
    handleEdit,
    handleSave,
    handleImageUpload
    
  };
};
